import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import {
  installWindowLifecycleListeners,
} from '@amzn/ring-web-analytics';

import App from './App';
import { GlobalState } from './contexts/GlobalContext';
import { environment } from './utils/environment';
import { isAmazonHost } from './utils';
import { handleAmazonInitialRender } from './utils/handleAmazonInitialRender';

const root = ReactDOM.createRoot(document.getElementById('root'));

const getContent = () => (
  <GlobalState>
    <App />
  </GlobalState>
);

// Initialize RWA DOM utilities if not on Amazon host
if (!isAmazonHost() && typeof window !== 'undefined') {
  // We'll set up a MutationObserver to wait for RWA to be initialized
  const setupRWA = () => {
    if (!window.RWA) return;
    
    // Install window lifecycle listeners for visibility changes
    installWindowLifecycleListeners(window, window.RWA);
  };
  
  // Try to set up RWA immediately if available
  setupRWA();
  
  // If RWA isn't available yet, check periodically
  if (!window.RWA) {
    const checkInterval = setInterval(() => {
      if (window.RWA) {
        setupRWA();
        clearInterval(checkInterval);
      }
    }, 1000);
    
    // Clean up interval after 10 seconds if RWA never initializes
    setTimeout(() => clearInterval(checkInterval), 10000);
  }
}

root.render(
  isAmazonHost() ? (
    <HashRouter>{getContent()}</HashRouter>
  ) : (
    <BrowserRouter basename={environment.basename}>
      {getContent()}
    </BrowserRouter>
  )
);

handleAmazonInitialRender();